import type { RasterizeSvgOntoCanvas } from "./types";

export const rasterizeSvgOntoCanvas: RasterizeSvgOntoCanvas = ({
  svgString,
  context,
  canvasWidth,
  canvasHeight,
}) =>
  new Promise<void>((resolve, reject) => {
    const blob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
    const objectUrl = URL.createObjectURL(blob);
    const image = new Image();

    image.onload = () => {
      try {
        context.drawImage(image, 0, 0, canvasWidth, canvasHeight);
        URL.revokeObjectURL(objectUrl);
        resolve();
      } catch (drawError) {
        URL.revokeObjectURL(objectUrl);
        reject(drawError);
      }
    };

    image.onerror = (loadError) => {
      URL.revokeObjectURL(objectUrl);
      reject(loadError);
    };

    image.src = objectUrl;
  });
